export default __webpack_public_path__ + "static/media/padlock_green_icone.bcb2e384.svg";